import React, { useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function MothersTestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = [{
    name: 'Maria S.',
    role: 'Mother of 8-month-old',
    content: "Before 'Baby Food Made Simple,' mealtime was a battlefield. Now my daughter opens her mouth like a little bird, eager for the next bite. The weekly meal plans saved my sanity!",
    rating: 5
  }, {
    name: 'Sophia L.',
    role: 'Mother of twins',
    content: "As a mom of twins, I was drowning in stress trying to feed them properly. Dr. Morgan's system gave me the structure I desperately needed. Both babies are thriving now!",
    rating: 5
  }, {
    name: 'Emma K.',
    role: 'First-time mom',
    content: 'The texture progression guide helped me overcome my fear of choking. Now I confidently introduce new foods, and my son explores everything! Worth every penny.',
    rating: 5
  }, {
    name: 'Lisa T.',
    role: 'Mother & pediatric nurse',
    content: 'Even with my medical background, I struggled with feeding my daughter. This system is scientifically sound and practical. The allergen introduction protocol is especially valuable.',
    rating: 5
  }];
  const nextTestimonial = () => {
    setCurrentIndex(prevIndex => prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1);
  };
  const prevTestimonial = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1);
  };
  const goToTestimonial = (index: number) => {
    setCurrentIndex(index);
  };
  return <section className="py-8 bg-blue-50" data-id="element-247">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-249">
          <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-250">
            What Mothers Are Saying
          </h2>
          <div className="h-1 w-20 bg-yellow-500 mx-auto mb-6" data-id="element-251"></div>
          <p className="text-lg text-gray-700" data-id="element-252">
            Join thousands of moms who transformed mealtime from stress to
            success
          </p>
        </div>
        {/* Testimonial Carousel */}
        <div className="relative max-w-3xl mx-auto" data-id="element-253">
          <div className="overflow-hidden rounded-xl" data-id="element-254">
            <div className="transition-transform duration-300 ease-in-out" style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }} data-id="element-255">
              <div className="flex" data-id="element-256">
                {testimonials.map((testimonial, index) => <div key={index} className="w-full flex-shrink-0 p-6" style={{
                minWidth: '100%'
              }} data-id="element-257">
                    <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-258">
                      <div className="flex mb-4" data-id="element-259">
                        {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-500 fill-current" data-id="element-260" />)}
                      </div>
                      <p className="text-gray-700 mb-6 italic text-lg" data-id="element-261">
                        "{testimonial.content}"
                      </p>
                      <div data-id="element-262">
                        <p className="font-bold text-gray-900" data-id="element-263">
                          {testimonial.name}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-264">
                          {testimonial.role}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
          {/* Navigation Buttons */}
          <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors z-10" aria-label="Previous testimonial" data-id="element-265">
            <ChevronLeftIcon className="h-6 w-6 text-gray-800" data-id="element-266" />
          </button>
          <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors z-10" aria-label="Next testimonial" data-id="element-267">
            <ChevronRightIcon className="h-6 w-6 text-gray-800" data-id="element-268" />
          </button>
          {/* Indicators */}
          <div className="flex justify-center mt-6 space-x-2" data-id="element-269">
            {testimonials.map((_, index) => <button key={index} onClick={() => goToTestimonial(index)} className={`h-3 w-3 rounded-full transition-colors ${currentIndex === index ? 'bg-blue-600' : 'bg-gray-300'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-270" />)}
          </div>
        </div>
        <div className="mt-16 bg-white p-8 rounded-xl shadow-md max-w-3xl mx-auto" data-id="element-271">
          <div className="flex items-center justify-center mb-6" data-id="element-272">
            <div className="h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-273">
              <span className="text-2xl font-bold text-blue-600" data-id="element-274">97%</span>
            </div>
          </div>
          <p className="text-center text-lg font-medium text-gray-700" data-id="element-275">
            Of mothers report significant reduction in mealtime stress within
            the first week of using the system
          </p>
        </div>
      </div>
    </section>;
}